import Image from "next/legacy/image";
import * as S from "./MktLandingPageSeniorMentCard.style";
import { mktLandingPageSeniorsMentData } from "src/models/landing/seniors/seniors";
import quotation from "public/images/landing/seniors/quotation.png";

export default function MktLandingPageSeniorMentCard({ slideIndex }) {
  return (
    <>
      <S.DesktopCarouselContainer>
        {mktLandingPageSeniorsMentData
          .slice(slideIndex, slideIndex + 3)
          .map(({ id, ment, name, role, logo }) => (
            <S.Card key={id}>
              <div>
                <Image src={quotation} alt="quotation" width={25} height={20} />
                <S.Ment>{ment}</S.Ment>
              </div>
              <div>
                <S.SeniorInfo>
                  <S.SeniorName>{name}</S.SeniorName>
                  <S.VerticalLine></S.VerticalLine>
                  <S.SeniorRole>{role}</S.SeniorRole>
                </S.SeniorInfo>
                <S.LogoWrapper logoId={id}>
                  <Image
                    src={logo}
                    layout="fill"
                    objectFit="cover"
                    objectPosition="center"
                    alt="logo"
                  />
                </S.LogoWrapper>
              </div>
            </S.Card>
          ))}
      </S.DesktopCarouselContainer>
      <S.MobileCarouselContainer>
        {mktLandingPageSeniorsMentData.map(({ id, ment, name, role, logo }) => (
          <S.Card key={id}>
            <div>
              <Image src={quotation} alt="quotation" width={20} height={16} />
              <S.Ment>{ment}</S.Ment>
            </div>
            <div>
              <S.SeniorInfo>
                <S.SeniorName>{name}</S.SeniorName>
                <S.VerticalLine />
                <S.SeniorRole>{role}</S.SeniorRole>
              </S.SeniorInfo>
              <S.LogoWrapper logoId={id}>
                <Image
                  src={logo}
                  layout="fill"
                  objectFit="cover"
                  objectPosition="center"
                  alt="logo"
                />
              </S.LogoWrapper>
            </div>
          </S.Card>
        ))}
      </S.MobileCarouselContainer>
    </>
  );
}
